<main  *ngIf="welcome">
    <div class="welcome" *ngIf="this.isDataAvailable">
        <div *ngIf="errorMessage" class="alert valign-children-middle error-container">
            <div class="alert-error" role="img">
                <i class="icon-badgealert" aria-label="alert"></i>
            </div>
            <div>{{errorMessage}}</div>
        </div>
        <h1> Welcome, {{user.firstName}} {{user.lastName}} </h1>
        <div class="row signupContent">
           <!-- <div class="col-sm-12 col-md-5 mediaStop" id="player" (click)="playVideo()">-->
                <!-- product tiles end  -->
                <!--app-video [url]='this.welcome.video.link' [idx]="'123'"></app-video-->
           <!--  <att-gvp [attr.video]="videoId" (click)="adobeLinkClick()"></att-gvp>
            </div>-->
            <div class="col-sm-12 col-view" id = "image">
                <img class="viewimg" src="{{welcome.image.img}}"/>
                <div class="col-sm-12 col-md-5 row">
                    <div class="box1"></div>
                    <div class="box2"></div>
                    <div class="box3"></div>
                    <div class="box4"></div>
                    <div class="box5"></div>
                    <div class="box6"></div>
                </div>
            </div>
            <div class="col-sm-12 col-md-7 title-space">
                <h2> {{welcome.header1.value}}</h2>
                <p> {{welcome.desc1.value}} </p>
                <ul>
                    <li>
                        <a href="https://www.apple.com/business/it/" target="_blank">
                            <span> {{welcome.desc8.value}} </span></a> 
                            <span> {{ welcome.desc8.value1}} </span>
                    </li>
                    <li>
                        <a href="https://www.samsungknox.com/en/solutions/it-solutions/knox-mobile-enrollment" target="_blank">
                            <span> {{welcome.desc2.value}} </span></a> 
                            <span> {{ welcome.desc2.value1}} </span>
                    </li>
                    <li>
                        <a href="https://www.android.com/intl/en_hk/enterprise/management/zero-touch" target="_blank">
                            <span> {{welcome.desc3.value}} </span></a> 
                            <span> {{ welcome.desc3.value1}} </span>
                    </li>
                    <li>
                        <span> {{welcome.desc4.value1}} </span>
                        <a href="https://www.business.att.com/portfolios/cybersecurity.html" target="_blank"> 
                         <span> {{ welcome.desc4.value}} </span></a> 
                        
                    </li>
                        
                </ul>
                
               
            </div>
            <br/>
            <div class="botcont">

                <p> {{welcome.desc5.value}} </p>
                <p> {{welcome.desc6.value}} </p>
                <p> {{welcome.desc7.value}} </p>
                <ul><li *ngFor="let x of welcome.desc3.value">{{x}}</li></ul>
               <!-- <a href="javascript:void(0)" (click)="openOverviewModal()"  title="Opens a dialog"> {{welcome.referencelink.value}} </a>
                -->
                <div *ngIf="initModal">
                    <app-modal *ngIf="showOverviewModal" [showModal]="showOverviewModal" [modalClass]="modalClass">
                    <app-confirm-modal [modalPopupObject]='confirmModalPopup' [triggerElement]='eventEmit' (modalOutput)="closeModal($event)">
                    </app-confirm-modal>
                    </app-modal>
                </div>
                    
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-md-12 text-right">
                <!--<button class="btn btn-secondary pull-right"> {{this.welcome.btnname}} </button>-->
                <button (click)="moveToEnrollment()" class="btn btn-secondary pull-right" [checkRole]="welcome.fieldPermissions.signup" [disabled]="hasAccess"> {{welcome.letStart.value}} </button>
                <a href="javascript:void(0)" (click)="back()" class="btn btn-link btn-block btn-cancel welcome-btn-cancel"> {{welcome.cancel.value}} </a>
            </div>
        </div>
    </div>
</main>
